// Actions
const CHANGE_LOADING_STATE = 'changeLoadingState'
const CHANGE_PROJECT_LOADING_STATE = 'changeProjectLoadingState'
const CHANGE_ACTIVE_PROJECT = 'changeActiveProject'
const LOAD_LANDLORD_DETAILS = 'loadLandlordDetails'
const LOAD_PROJECT_AVAILABILITY = 'loadProjectAvailability'
const CHANGE_FILTER_STATE = 'changeFilterState'
const RESET_FILTERS = 'resetFilters'
const RESET_FLOOR_FILTER = 'resetFloorFilter'
const CLEAR_AMENITIES = 'clearAmenities'
const LOAD_TOTAL_AVAILABLE_RESULTS = 'loadTotalAvailableResults'
const CHANGE_CURRENT_SPACE = 'changeCurrentSpace'
const UPDATE_SURFACE_MULTIPLIER = 'updateSurfaceMultiplier'
const UPDATE_SURFACE_NAME = 'updateSurfaceName'
const LOAD_SPACE_DATA = 'loadSpaceData'
const RESET_SURFACE_FIELDS = 'resetSurfaceFields'

// Mutations
const SET_LANDLORD_DETAILS = 'setLandlordDetails'
const SET_LOADING_STATE = 'setLoadingState'
const SET_PROJECT_LOADING_STATE = 'setProjectLoadingState'
const SET_PROJECT_AVAILABILITY = 'setProjectAvailability'
const SET_ACTIVE_PROJECT = 'setActiveProject'
const SET_FILTER_STATE = 'setFilterState'
const SET_EMPTY_FILTERS = 'setEmptyFilters'
const SET_TOTAL_AVAILABLE_RESULTS = 'setTotalAvailableResults'
const SET_CURRENT_SPACE = 'setCurrentState'
const SET_SURFACE_MULTIPLIER = 'setSurfaceMultiplier'
const SET_SURFACE_NAME = 'setSurfaceName'
const SET_SPACE_DATA = 'setSpaceData'
const SET_COMBINED_SPACE_DATA = 'setCombinedSpaceData'
const SET_DEFAULT_SURFACE_FIELDS = 'setDefaultSurfaceFields'

// Namespace
const NAMESPACE = 'project'

const withNamespace = (string: string) => {
  return `${NAMESPACE}/${string}`
}

export default {
  action: {
    CHANGE_LOADING_STATE,
    CHANGE_PROJECT_LOADING_STATE,
    CHANGE_ACTIVE_PROJECT,
    LOAD_LANDLORD_DETAILS,
    LOAD_PROJECT_AVAILABILITY,
    CHANGE_FILTER_STATE,
    RESET_FILTERS,
    RESET_FLOOR_FILTER,
    CLEAR_AMENITIES,
    LOAD_TOTAL_AVAILABLE_RESULTS,
    CHANGE_CURRENT_SPACE,
    UPDATE_SURFACE_MULTIPLIER,
    UPDATE_SURFACE_NAME,
    LOAD_SPACE_DATA,
    RESET_SURFACE_FIELDS
  },
  mutation: {
    SET_LANDLORD_DETAILS,
    SET_LOADING_STATE,
    SET_ACTIVE_PROJECT,
    SET_PROJECT_LOADING_STATE,
    SET_PROJECT_AVAILABILITY,
    SET_FILTER_STATE,
    SET_EMPTY_FILTERS,
    SET_TOTAL_AVAILABLE_RESULTS,
    SET_CURRENT_SPACE,
    SET_SURFACE_MULTIPLIER,
    SET_SURFACE_NAME,
    SET_SPACE_DATA,
    SET_COMBINED_SPACE_DATA,
    SET_DEFAULT_SURFACE_FIELDS
  },
  namespace: NAMESPACE,
  withNamespace
}
